import React, { Component } from "react";
import { Input, message, Modal, Empty, Select, Drawer } from "antd";
import { Redirect } from "react-router";
import utils from "../../../utils/common";
import "./orderList.less";

const Option = Select.Option;
const Search = Input.Search;

function Status({ status }) {
  let text = "";
  let cls = "order-status";
  switch (status) {
    case 0:
      text = "等待付款";
      cls += " order-status--pending";
      break;
    case 1:
      text = "等待发货";
      cls += " order-status--shipping";
      break;
    case 2:
      text = "等待收货";
      cls += " order-status--receiving";
      break;
    case 3:
      text = "已完成";
      cls += " order-status--finished";
      break;
    case 4:
      text = "已取消";
      cls += " order-status--cancelled";
      break;
    case 5:
      text = "已退款";
      cls += " order-status--refunded";
      break;
    default:
      text = "";
  }
  return <p className={cls}>{text}</p>;
}

class OrderList extends Component {
  state = {
    list: [],
    tabStatus: 0, //  页面 tab的状态
    status: 0, // 对应接口参数 0：全部订单，1：等待付款，2：等待发货，3：等待收货，4：已完成，5：已取消，6：已退款（默认0）
    loadMore: true, // 是否能加载更多
    loadText: "加载更多",
    ModalText: "确认取消当前订单？",
    visible: false,
    confirmLoading: false,
    snVisible: false, // sn码弹窗
    orderNo: null, // 搜索的订单号
    cancelOrderNo: null, // 将要取消的订单编号
    cancelIndex: null, // 将要取消订单的索引
    redirect: false,
    snList: [], // sn码列表
    statusList: [
      "全部订单",
      "等待付款",
      "等待发货",
      "等待收货",
      "已完成",
      "已取消",
      "已退款"
    ], // 状态列表
    sourceCMS: "" // 来源标识
  };

  componentWillMount() {
    if (window.common.loginOut(this)) {
      const sourceCMS = window.localStorage.getItem("sourceCMS") || "";

      // 根据sourceCMS动态设置状态列表
      let statusList = [
        "全部订单",
        "等待付款",
        "等待发货",
        "等待收货",
        "已完成",
        "已取消",
        "已退款"
      ];
      if (sourceCMS === "1") {
        // sourceCMS为1时，只显示已完成、等待付款、已取消、已退款
        statusList = ["全部订单", "等待付款", "已完成", "已取消", "已退款"];
      }

      this.setState({ sourceCMS, statusList });
      this.getOrderList("first");
    } else {
      message.error("登录信息失效，请重新登录");
    }
  }

  // 跳转到订单详情
  toOrderDetail = orderNo => {
    this.props.history.push("/orderDetail", { order_no: orderNo });
  };

  // 变更搜索的订单状态
  changeStatus = async status => {
    console.log(status);
    // sourceCMS为1时，状态列表为：['全部订单', '等待付款', '已完成', '已取消', '已退款']
    // 对应状态值：0：全部订单，1：等待付款，4：已完成，5：已取消，6：已退款（默认0）
    let tabStatus = 0;
    const { sourceCMS } = this.state;
    if (sourceCMS === "1") {
      if (status < 2) {
        tabStatus = status;
      } else if (status === 2) {
        tabStatus = 2;
        status = 4;
      } else if (status === 3) {
        tabStatus = 3;
        status = 5;
      } else if (status === 4) {
        tabStatus = 4;
        status = 6;
      }
    } else {
        tabStatus = status;
    }

    await this.setState({
      status,
      tabStatus,
      orderNo: null
    });
    this.getOrderList("change");
  };

  // 按订单编号搜索订单
  searchOrder = async value => {
    const orderNo = utils.deleteBlank(value);
    await this.setState({ orderNo, status: 0, tabStatus: 0 });
    this.getOrderList("change");
  };

  // 获取订单列表
  getOrderList(type) {
    let list = this.state.list;
    const { status, orderNo } = this.state;
    let params = { status, page_size: 10 };
    orderNo ? (params.order_no = orderNo) : null;
    params = utils.dealElement(params);
    if (type === "next") {
      this.setState({ loadText: "正在加载..." });
      params.next = list[list.length - 1].order_no;
    }
    window
      .api("order.orderList", params)
      .then(res => {
        let operation = {};
        res.orders.length < 10
          ? (operation = { loadMore: false, loadText: "已加载全部订单" })
          : (operation = { loadMore: true, loadText: "加载更多" });
        type === "change"
          ? (list = res.orders)
          : (list = list.concat(res.orders));
        operation.list = list;
        this.setState({ ...operation });
      })
      .catch(error => {
        error.service_error_code === "EPS000000801"
          ? this.setState({ redirect: true })
          : null;
        message.error(error.service_error_message);
      });
  }

  // 付款
  pay = index => {
    const { list } = this.state;
    const detail = list[index].order_details[0];
    const info = {
      order_no: detail.order_no,
      real_amt: detail.real_amt,
      total_amt: detail.total_amt,
      address: `${list[index].province} ${list[index].city} ${list[index].area
        } ${list[index].address}`,
      goods_name: detail.goods_name,
      type: detail.goods_type
    };
    this.props.history.push("/cashier", { info });
  };

  // 取消订单
  cancelOrder = async () => {
    this.setState({ ModalText: "正在支付，请稍候", confirmLoading: true });
    const { list, cancelOrderNo, cancelIndex } = this.state;
    window
      .api("order.cancelOrder", { order_no: cancelOrderNo })
      .then(res => {
        message.success("已取消");
        list[cancelIndex].order_details[0].status = 4;
        this.setState({
          visible: false,
          confirmLoading: false,
          ModalText: "确认取消当前订单？",
          list
        });
      })
      .catch(error => {
        error.service_error_code === "EPS000000801"
          ? this.setState({ redirect: true })
          : null;
        this.setState({
          visible: false,
          confirmLoading: false,
          ModalText: "确认取消当前订单？"
        });
        message.error(error.service_error_message);
      });
  };

  // 确认收货
  confirmReceipt = (orderNo, ids, index) => {
    const { list } = this.state;
    const params = { order_no: orderNo, ids: `${ids}` };
    window
      .api("order.confirmReceived", params)
      .then(res => {
        list[index].order_details[0].status = 3;
        this.setState({ list });
        message.success("确认收货，已完成订单！");
      })
      .catch(error => {
        error.service_error_code === "EPS000000801"
          ? this.setState({ redirect: true })
          : null;
        message.error(error.service_error_message);
      });
  };

  // 订单检测
  detection = item => {
    const { orderNo, payOrderNo } = item.order_extend;
    window
      .api("order.receptionPaymentResult", {
        pay_order_no: payOrderNo,
        out_trade_no: orderNo,
        trade_status: "SUCCESS",
        service_type: 1,
        pay_date: utils.getNowFormatDate(0)
      })
      .then(res => { })
      .catch(error => {
        message.error(error.service_error_message);
      });
  };

  // 打开取消窗口
  showModal = (orderNo, cancelIndex) => {
    this.setState({ visible: true, cancelOrderNo: orderNo, cancelIndex });
  };

  // 打开sn列表窗口
  openSnModal(snList) {
    this.setState({ snVisible: true, snList });
  }

  // 关闭取消窗口
  handleCancel = () => {
    this.setState({ visible: false, snVisible: false });
  };

  render() {
    const {
      list,
      loadMore,
      loadText,
      visible,
      confirmLoading,
      ModalText,
      statusList,
      snList,
      tabStatus,
      redirect,
      snVisible,
      sourceCMS
    } = this.state;
    if (redirect) return <Redirect to="/login" />;
    return (
      <div id="orderList">
        <section
          className="bar"
          style={{ top: sourceCMS === "1" ? "0px" : "180px" }}
        />
        <header
          className="title"
          style={{ top: sourceCMS === "1" ? "30px" : "210px" }}
        >
          <ul>
            {statusList.map((item, index) => (
              <li
                className={Number(tabStatus) === index ? "isChecked" : null}
                key={index}
                onClick={this.changeStatus.bind(this, index)}
              >
                {item}
              </li>
            ))}
          </ul>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              justifyContent: "flex-end"
            }}
          >
            <Search
              className="searchInput"
              placeholder="订单编号"
              enterButton="搜索"
              size="default"
              onSearch={this.searchOrder.bind(this)}
            />
          </div>
        </header>
        <section
          className="bar bar2"
          style={{ top: sourceCMS === "1" ? "76px" : "257px" }}
        />
        <section
          className="top"
          style={{ paddingTop: sourceCMS === "1" ? "12px" : "12px" }}
        >
          <ul className="order">
            {list.map((item2, index2) => (
              <li key={index2}>
                <div className="title">
                  <div
                    style={{
                      width: "300px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    <span>{`${item2.created_no}/${item2.agent_name}`}</span>
                  </div>
                  <div style={{ width: "280px" }}>
                    <span style={{ color: "#000" }}>创建时间：</span>
                    <span>{item2.gmt_created}</span>
                  </div>
                  <div style={{ width: "300px" }}>
                    <span style={{ color: "#000" }}>订单号：</span>
                    <span>{item2.order_no}</span>
                  </div>
                </div>
                <div className="content">
                  <div style={{ width: "450px" }} className="info">
                    <img src={item2.order_details[0].goods_pic} />
                    <p>{item2.order_details[0].goods_name}</p>
                  </div>
                  <p style={{ width: "120px" }}>
                    数量：{item2.order_details[0].goods_qty}
                  </p>
                  <p style={{ width: "120px" }}>
                    实付款：￥{item2.order_details[0].total_amt.toFixed(2)}
                  </p>
                  <div
                    style={{
                      width: "100px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <Status status={item2.order_details[0].status} />
                    <p
                      style={{ marginTop: "10px", cursor: "pointer" }}
                      onClick={this.toOrderDetail.bind(
                        this,
                        item2.order_details[0].order_no,
                        item2
                      )}
                    >
                      订单详情
                    </p>
                  </div>
                  {// 支付方式为3时 并且 是待付款状态时，显示检测按钮
                    item2.pay_type === 3 &&
                      item2.order_details[0].status === 0 ? (
                      <div className="operation">
                        <button
                          onClick={this.detection.bind(this, item2)}
                          style={{ backgroundColor: "orange" }}
                        >
                          订单检测
                        </button>
                        {item2.order_details[0].status === 0 ? (
                          <div>
                            <button onClick={this.pay.bind(this, index2)}>
                              付款
                            </button>
                            <p
                              onClick={this.showModal.bind(
                                this,
                                item2.order_details[0].order_no,
                                index2
                              )}
                            >
                              取消订单
                            </p>
                          </div>
                        ) : null}
                      </div>
                    ) : (
                      <div className="operation">
                        {item2.order_details[0].sn_list !== null ? (
                          <p
                            onClick={this.openSnModal.bind(
                              this,
                              item2.order_details[0].sn_list
                            )}
                            style={{ color: "#009dd2" }}
                          >
                            查看sn码
                          </p>
                        ) : null}
                        {item2.order_details[0].status === 2 ? (
                          <button
                            onClick={this.confirmReceipt.bind(
                              this,
                              item2.order_details[0].order_no,
                              item2.order_details[0].id,
                              index2
                            )}
                          >
                            确认收货
                          </button>
                        ) : null}
                        {item2.order_details[0].status === 0 ? (
                          <div>
                            <button onClick={this.pay.bind(this, index2)}>
                              付款
                            </button>
                            <p
                              onClick={this.showModal.bind(
                                this,
                                item2.order_details[0].order_no,
                                index2
                              )}
                            >
                              取消订单
                            </p>
                          </div>
                        ) : null}
                      </div>
                    )}
                </div>
              </li>
            ))}
          </ul>
        </section>
        <section className="pagination" hidden={list.length === 0}>
          {loadMore ? (
            <button onClick={this.getOrderList.bind(this, "next")}>
              {loadText}
            </button>
          ) : (
            <button>{loadText}</button>
          )}
        </section>
        <section className="default" hidden={list.length > 0}>
          <Empty />
        </section>
        <div>
          <Modal
            visible={visible}
            onOk={this.cancelOrder}
            confirmLoading={confirmLoading}
            onCancel={this.handleCancel}
          >
            <p>{ModalText}</p>
          </Modal>
          <Drawer
            visible={snVisible}
            onClose={this.handleCancel}
            placement="right"
            closable={false}
            title="Sn列表"
          >
            {snList.map((item, index) => (
              <p style={{ width: "200px" }} key={index}>
                {item}
              </p>
            ))}
          </Drawer>
        </div>
      </div>
    );
  }
}

export default OrderList;



// WEBPACK FOOTER //
// ./src/containers/frontEnd/orderList/orderList.jsx